import { ConfigurationDTO } from "@/model/data.model";
import cloneDeep from "lodash/cloneDeep";

export function getKeyValueConfig(
  keys: ConfigurationDTO[],
  key: string,
  level?: string
) {
  const filteredKeys = keys.filter(item => {
    return item.confKey === key;
  });
  const storeObj = filteredKeys.find(obj => obj.storeId !== null);
  if (storeObj && (level ? level === "store" : true)) {
    return storeObj.confValue === "true";
  } else {
    const multiStoreObj = filteredKeys.find(obj => obj.multistoreId !== null);
    if (multiStoreObj && (level ? level === "multistore" : true)) {
      return multiStoreObj.confValue === "true";
    } else {
      const tenantObj = filteredKeys.find(obj => obj.tenantId !== null);
      if (tenantObj && (level ? level === "tenant" : true)) {
        return tenantObj.confValue === "true";
      } else {
        return false;
      }
    }
  }
}
